import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const PremiumIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M38.6035 52.9525V34.0002C38.6035 28.4774 43.0807 24.0002 48.6035 24.0002H115.404C120.927 24.0002 125.404 28.4774 125.404 34.0002V52.9525"
                stroke={color}
                strokeWidth="6"
                strokeMiterlimit="8"
            />
            <path
                d="M30 109.003C24.4771 109.003 20 104.526 20 99.0035V68.703C20 60.147 26.944 53.203 35.5 53.203C44.056 53.203 51 60.147 51 68.703V84.203H113V68.703C113 60.147 119.944 53.203 128.5 53.203C137.056 53.203 144 60.147 144 68.703V99.0035C144 104.526 139.523 109.003 134 109.003H30Z"
                stroke={color}
                strokeWidth="6"
                strokeMiterlimit="8"
            />
            <path d="M44.001 108L36.001 136" stroke={color} strokeWidth="6" strokeMiterlimit="8" />
            <path d="M120 108L128 136" stroke={color} strokeWidth="6" strokeMiterlimit="8" />
        </svg>
    );
};
